"use strict";

require("core-js/modules/es6.function.bind");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.subscribeToTranslationChange = exports.unSubscribeToTranslationChange = void 0;

var _postMessageHelper = _interopRequireDefault(require("@eig-builder/core-utils/helpers/post-message-helper"));
/**
 * un Subscribe To Tanslation Change - call this method during componentWillUnmount
 * it will clear and remove the postMessageHandler
 */


var unSubscribeToTranslationChange = function unSubscribeToTranslationChange(postMessageHandler, setPostMessageHandler) {
  if (postMessageHandler) {
    postMessageHandler.clear();
    setPostMessageHandler(null);
  }
};
/**
 * subscribe To Tanslation Change to the post messages, that are send from the iframe inside the inline editor modal
 * the new translation will be showed after it was received
 *
 *
 */


exports.unSubscribeToTranslationChange = unSubscribeToTranslationChange;

var subscribeToTranslationChange = function subscribeToTranslationChange(message, textSpan, postMessageHandler, setPostMessageHandler) {
  setPostMessageHandler(new _postMessageHelper["default"]());
  postMessageHandler.bind('translation_message', function (data) {
    if (data.key === message && textSpan) {
      if (textSpan.textContent) {
        textSpan.textContent = data.text;
      } else if (textSpan.innerHtml) {
        textSpan.innerHtml = data.text;
      }
    }
  });
  window.localizationPopup.close();
};

exports.subscribeToTranslationChange = subscribeToTranslationChange;